"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.keys.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TooltipHandle = exports.Tooltip = exports.Slider = void 0;
require("core-js/modules/es.array.concat.js");
var _react = require("@emotion/react");
var _core = require("../../core");
var _currencyHelpers = require("../../helpers/currencyHelpers");
var _eero = require("../../theme/eero");
var _SliderBase = _interopRequireDefault(require("./SliderBase"));
var _excluded = ["backgroundColor", "children"],
  _excluded2 = ["handle", "handleColor", "hideTooltip", "isCurrencyDisplay", "getHandleProps"],
  _excluded3 = ["trackColor", "source", "target", "getTrackProps"],
  _excluded4 = ["min", "max", "value", "update", "onChange", "onUpdate"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function cov_20t2jyyz91() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/Slider/Slider.tsx";
  var hash = "bdb2ba59051414342a59099a779cbe1f0dbfc8f5";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/Slider/Slider.tsx",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 22
        },
        end: {
          line: 9,
          column: 24
        }
      },
      "1": {
        start: {
          line: 10,
          column: 15
        },
        end: {
          line: 10,
          column: 16
        }
      },
      "2": {
        start: {
          line: 11,
          column: 22
        },
        end: {
          line: 11,
          column: 24
        }
      },
      "3": {
        start: {
          line: 13,
          column: 41
        },
        end: {
          line: 26,
          column: 1
        }
      },
      "4": {
        start: {
          line: 14,
          column: 2
        },
        end: {
          line: 25,
          column: 4
        }
      },
      "5": {
        start: {
          line: 28,
          column: 44
        },
        end: {
          line: 49,
          column: 1
        }
      },
      "6": {
        start: {
          line: 29,
          column: 2
        },
        end: {
          line: 48,
          column: 9
        }
      },
      "7": {
        start: {
          line: 51,
          column: 64
        },
        end: {
          line: 81,
          column: 1
        }
      },
      "8": {
        start: {
          line: 59,
          column: 2
        },
        end: {
          line: 80,
          column: 8
        }
      },
      "9": {
        start: {
          line: 83,
          column: 48
        },
        end: {
          line: 107,
          column: 1
        }
      },
      "10": {
        start: {
          line: 90,
          column: 2
        },
        end: {
          line: 106,
          column: 4
        }
      },
      "11": {
        start: {
          line: 109,
          column: 52
        },
        end: {
          line: 130,
          column: 1
        }
      },
      "12": {
        start: {
          line: 118,
          column: 2
        },
        end: {
          line: 129,
          column: 4
        }
      },
      "13": {
        start: {
          line: 122,
          column: 26
        },
        end: {
          line: 122,
          column: 57
        }
      },
      "14": {
        start: {
          line: 123,
          column: 26
        },
        end: {
          line: 123,
          column: 57
        }
      },
      "15": {
        start: {
          line: 127,
          column: 29
        },
        end: {
          line: 127,
          column: 77
        }
      },
      "16": {
        start: {
          line: 128,
          column: 28
        },
        end: {
          line: 128,
          column: 48
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 13,
            column: 41
          },
          end: {
            line: 13,
            column: 42
          }
        },
        loc: {
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 25,
            column: 4
          }
        },
        line: 14
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 28,
            column: 44
          },
          end: {
            line: 28,
            column: 45
          }
        },
        loc: {
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 48,
            column: 9
          }
        },
        line: 29
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 51,
            column: 64
          },
          end: {
            line: 51,
            column: 65
          }
        },
        loc: {
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 80,
            column: 8
          }
        },
        line: 59
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 83,
            column: 48
          },
          end: {
            line: 83,
            column: 49
          }
        },
        loc: {
          start: {
            line: 90,
            column: 2
          },
          end: {
            line: 106,
            column: 4
          }
        },
        line: 90
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 109,
            column: 52
          },
          end: {
            line: 109,
            column: 53
          }
        },
        loc: {
          start: {
            line: 118,
            column: 2
          },
          end: {
            line: 129,
            column: 4
          }
        },
        line: 118
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 122,
            column: 14
          },
          end: {
            line: 122,
            column: 15
          }
        },
        loc: {
          start: {
            line: 122,
            column: 26
          },
          end: {
            line: 122,
            column: 57
          }
        },
        line: 122
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 123,
            column: 14
          },
          end: {
            line: 123,
            column: 15
          }
        },
        loc: {
          start: {
            line: 123,
            column: 26
          },
          end: {
            line: 123,
            column: 57
          }
        },
        line: 123
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 127,
            column: 18
          },
          end: {
            line: 127,
            column: 19
          }
        },
        loc: {
          start: {
            line: 127,
            column: 29
          },
          end: {
            line: 127,
            column: 77
          }
        },
        line: 127
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 128,
            column: 17
          },
          end: {
            line: 128,
            column: 18
          }
        },
        loc: {
          start: {
            line: 128,
            column: 28
          },
          end: {
            line: 128,
            column: 48
          }
        },
        line: 128
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 60,
            column: 5
          },
          end: {
            line: 64,
            column: 5
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 60,
            column: 5
          },
          end: {
            line: 60,
            column: 16
          }
        }, {
          start: {
            line: 61,
            column: 6
          },
          end: {
            line: 63,
            column: 16
          }
        }],
        line: 60
      },
      "1": {
        loc: {
          start: {
            line: 62,
            column: 9
          },
          end: {
            line: 62,
            column: 58
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 62,
            column: 29
          },
          end: {
            line: 62,
            column: 50
          }
        }, {
          start: {
            line: 62,
            column: 53
          },
          end: {
            line: 62,
            column: 58
          }
        }],
        line: 62
      },
      "2": {
        loc: {
          start: {
            line: 122,
            column: 26
          },
          end: {
            line: 122,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 122,
            column: 26
          },
          end: {
            line: 122,
            column: 34
          }
        }, {
          start: {
            line: 122,
            column: 38
          },
          end: {
            line: 122,
            column: 57
          }
        }],
        line: 122
      },
      "3": {
        loc: {
          start: {
            line: 123,
            column: 26
          },
          end: {
            line: 123,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 123,
            column: 26
          },
          end: {
            line: 123,
            column: 34
          }
        }, {
          start: {
            line: 123,
            column: 38
          },
          end: {
            line: 123,
            column: 57
          }
        }],
        line: 123
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "bdb2ba59051414342a59099a779cbe1f0dbfc8f5"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_20t2jyyz91 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_20t2jyyz91();
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; } /** @jsx jsx */
var HANDLE_RADIUS = (cov_20t2jyyz91().s[0]++, 28);
var HEIGHT = (cov_20t2jyyz91().s[1]++, 8);
var TOOLTIP_WIDTH = (cov_20t2jyyz91().s[2]++, 72);
cov_20t2jyyz91().s[3]++;
var TooltipArrow = function TooltipArrow(props) {
  cov_20t2jyyz91().f[0]++;
  cov_20t2jyyz91().s[4]++;
  return (0, _react.jsx)(_core.Box, _extends({
    left: "50%",
    ml: "-".concat(HEIGHT, "px"),
    borderWidth: "".concat(HEIGHT, "px ").concat(HEIGHT, "px 0"),
    borderColor: "transparent",
    borderStyle: "solid",
    position: "absolute",
    top: "".concat(HANDLE_RADIUS - HEIGHT, "px"),
    width: 0,
    height: 0
  }, props));
};
cov_20t2jyyz91().s[5]++;
var Tooltip = exports.Tooltip = function Tooltip(_ref2) {
  var backgroundColor = _ref2.backgroundColor,
    children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded);
  cov_20t2jyyz91().f[1]++;
  cov_20t2jyyz91().s[6]++;
  return (0, _react.jsx)(_core.Text, _extends({
    p: 2,
    textAlign: "center",
    size: "90",
    lineHeight: "100",
    position: "absolute",
    left: "-".concat(HANDLE_RADIUS, "px"),
    marginLeft: "-".concat(HANDLE_RADIUS, "px"),
    bottom: "".concat(HANDLE_RADIUS - HEIGHT, "px"),
    color: "neutrals0",
    backgroundColor: backgroundColor,
    cursor: "pointer"
    // @ts-expect-error Overriding border radius to custom widths
    ,
    borderRadius: "".concat(HEIGHT, "px"),
    minWidth: "".concat(TOOLTIP_WIDTH, "px")
  }, props), (0, _react.jsx)(TooltipArrow, {
    borderTopColor: backgroundColor
  }), children);
};
cov_20t2jyyz91().s[7]++;
var TooltipHandle = exports.TooltipHandle = function TooltipHandle(_ref3) {
  var _ref3$handle = _ref3.handle,
    id = _ref3$handle.id,
    value = _ref3$handle.value,
    percent = _ref3$handle.percent,
    handleColor = _ref3.handleColor,
    hideTooltip = _ref3.hideTooltip,
    isCurrencyDisplay = _ref3.isCurrencyDisplay,
    getHandleProps = _ref3.getHandleProps,
    props = _objectWithoutProperties(_ref3, _excluded2);
  cov_20t2jyyz91().f[2]++;
  cov_20t2jyyz91().s[8]++;
  return (0, _react.jsx)(_core.Box, _extends({
    cursor: "pointer"
  }, getHandleProps(id), props), (cov_20t2jyyz91().b[0][0]++, hideTooltip) || (cov_20t2jyyz91().b[0][1]++, (0, _react.jsx)(Tooltip, {
    left: "".concat(percent, "%"),
    backgroundColor: "neutrals90"
  }, isCurrencyDisplay ? (cov_20t2jyyz91().b[1][0]++, (0, _currencyHelpers.formatCurrency)(value)) : (cov_20t2jyyz91().b[1][1]++, value))), (0, _react.jsx)(_core.Card, {
    position: "absolute"
    // TODO(@cplat-fe): Fix this a11y violation
    // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
    ,
    role: "slider",
    left: "".concat(percent, "%"),
    width: "".concat(HEIGHT * 3, "px") // inner width + border
    ,
    height: "".concat(HEIGHT * 3, "px") // inner height + border
    ,
    border: "".concat(HEIGHT, "px solid ").concat(_eero.colors.neutrals0),
    borderRadius: "rounded",
    backgroundColor: handleColor,
    top: "-".concat(HEIGHT / 2, "px"),
    zIndex: 2,
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)"
  }));
};
cov_20t2jyyz91().s[9]++;
var _ref = process.env.NODE_ENV === "production" ? {
  name: "lb3lcq",
  styles: "user-select:none;-moz-user-select:none;-webkit-user-select:none"
} : {
  name: "wenk8i-Track",
  styles: "user-select:none;-moz-user-select:none;-webkit-user-select:none;label:Track;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var Track = function Track(_ref4) {
  var trackColor = _ref4.trackColor,
    source = _ref4.source,
    target = _ref4.target,
    getTrackProps = _ref4.getTrackProps,
    props = _objectWithoutProperties(_ref4, _excluded3);
  cov_20t2jyyz91().f[3]++;
  cov_20t2jyyz91().s[10]++;
  return (0, _react.jsx)(_core.Box, _extends({
    position: "absolute",
    height: "".concat(HEIGHT, "px"),
    borderRadius: "roundedSquare",
    cursor: "pointer",
    top: "".concat(HEIGHT / 2, "px"),
    left: "".concat(source.percent, "%"),
    width: "".concat(target.percent - source.percent, "%"),
    background: trackColor,
    css: _ref
  }, props, getTrackProps()));
};
cov_20t2jyyz91().s[11]++;
var Slider = exports.Slider = function Slider(_ref5) {
  var min = _ref5.min,
    max = _ref5.max,
    value = _ref5.value,
    _update = _ref5.update,
    _onChange = _ref5.onChange,
    _onUpdate = _ref5.onUpdate,
    rest = _objectWithoutProperties(_ref5, _excluded4);
  cov_20t2jyyz91().f[4]++;
  cov_20t2jyyz91().s[12]++;
  return (0, _react.jsx)(_SliderBase["default"], _extends({}, rest, {
    values: [value],
    update: [value],
    onUpdate: function onUpdate(update) {
      cov_20t2jyyz91().f[5]++;
      cov_20t2jyyz91().s[13]++;
      return (cov_20t2jyyz91().b[2][0]++, _onUpdate) && (cov_20t2jyyz91().b[2][1]++, _onUpdate(update[0]));
    },
    onChange: function onChange(values) {
      cov_20t2jyyz91().f[6]++;
      cov_20t2jyyz91().s[14]++;
      return (cov_20t2jyyz91().b[3][0]++, _onChange) && (cov_20t2jyyz91().b[3][1]++, _onChange(values[0]));
    },
    min: min,
    max: max,
    height: HEIGHT,
    renderHandle: function renderHandle(props) {
      cov_20t2jyyz91().f[7]++;
      cov_20t2jyyz91().s[15]++;
      return (0, _react.jsx)(TooltipHandle, _extends({}, props, {
        domain: [min, max]
      }));
    },
    renderTrack: function renderTrack(props) {
      cov_20t2jyyz91().f[8]++;
      cov_20t2jyyz91().s[16]++;
      return (0, _react.jsx)(Track, props);
    }
  }));
};
var _default = exports["default"] = Slider;